import { Component, Input, SimpleChanges } from "@angular/core";
import { PolicyHeaderComponent } from "../../policy-documents/policy-header/policy-header.component";
import { CommonModule } from "@angular/common";

@Component({
    selector: "app-aul-102-24",
    standalone: true,
    imports: [PolicyHeaderComponent, CommonModule],
    templateUrl: './aul-102-24.component.html',
    styleUrl: './aul-102-24.component.scss'
})
export class Aul10224Component{
    @Input() quoteDetails!: any;

    ngOnChanges(changes: SimpleChanges): void {
      if (changes['quoteDetails']) {
        const updatedAddressInfo = this.transformQuoteData(changes['quoteDetails'].currentValue?.aul10224);
        const transformedData = {...changes['quoteDetails'].currentValue?.aul10224, addressInfo: updatedAddressInfo};
        this.quoteDetails = transformedData;
      }
    }
  
    transformQuoteData(quoteData: any): any[] {
      const transformedAddresses = quoteData?.primaryAddress?.map((address: any) => {
        // Filter buildings and additional structures based on quoteAddressId
        const buildings = quoteData?.buildings?.filter((b: any) => b.quoteAddressId === address.addressId);
        const additionalStructures = quoteData?.additionalStructures?.filter((as: any) => as.quoteAddressId === address.addressId);
    
        // Return the transformed address object
        return {
          ...address,
          buildings,
          additionalStructures
        };
      });
    
      return transformedAddresses;
    }
}